import { createSlider }           from './swiper/createSlider.js';
import { createResponsiveSlider } from './swiper/createResponsiveSlider.js';

// Init
function init() {
    const sliderRoadmap = document.querySelectorAll('[data-slider="road-map"]');
    sliderRoadmap.forEach((el) => {
        const nextEl = el.querySelector('.map-slide-next');
        const prevEl = el.querySelector('.map-slide-prev');

        createSlider(el, {
            slidesPerView : 'auto',
            navigation    : {
                nextEl,
                prevEl
            }
        });
    });

    const sliderTg = document.querySelectorAll('[data-slider="tg"]');
    sliderTg.forEach((el) => {
        const nextEl = el.querySelector('.tg-slide-next');
        const prevEl = el.querySelector('.tg-slide-prev');

        createSlider(el, {
            slidesPerView : 'auto',
            spaceBetween  : 20,
            navigation    : {
                nextEl,
                prevEl
            }
        });
    });

    const sliderResize = document.querySelectorAll('[data-slider="resize"]');
    sliderResize.forEach((el) => {
        createResponsiveSlider(el, {
            breakpoint    : 681,
            freeMode      : false,
            slidesPerView : 'auto'
        });
    });

    const sliderEcosystem = document.querySelectorAll('[data-slider="ecosystem"]');
    sliderEcosystem.forEach((el) => {
        createResponsiveSlider(el, {
            breakpoint    : 1300,
            freeMode      : false,
            slidesPerView : 'auto'
        });
    });
}

(function () {
    init();
}());
